import { HttpParams } from '@angular/common/http';
import { isUndefined } from 'lodash-es';

type ParamType = string | number | boolean | string[] | number[] | boolean[];

export function toHttpParams(data: { [key: string]: ParamType }): HttpParams {
  let params = new HttpParams();

  for (const prop in data) {
    if (!isUndefined(data[prop])) {
      params = params.set(prop, String(data[prop]));
    }
  }

  return params;
}
